import { Box } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';

type BoxProps = React.ComponentProps<typeof Box>;

export const StyledContainer = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    css={{
      width: '100%',
      border: '1px solid',
      borderColor: 'gray.300',
      borderRadius: '5px',
      backgroundColor: 'white',
      padding: 'lg',
      marginBottom: 'sm',
    }}
    {...props}
  >
    {children}
  </Box>
);

export const StyledSummaryBox = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    css={{
      textAlign: 'center',
      padding: '32px 0',
    }}
    {...props}
  >
    {children}
  </Box>
);

export const StyledBalanceBox = ({ children, ...props }: { children: React.ReactNode } & BoxProps) => (
  <Box
    className={css({
      textAlign: { lg: 'right' },
    })}
    {...props}
  >
    {children}
  </Box>
);
